export enum TrackingEvent {
	ACH_BANK_TRANSFER = "ACH_BANK_TRANSFER",
	ADD_ITEMS_AND_CHECKOUT = "ADD_ITEMS_AND_CHECKOUT",
	ADD_ITEMS_TO_CART = "ADD_ITEMS_TO_CART",
	ADD_TO_CART = "ADD_TO_CART",
	BC_CHEMISTRY = "BC_CHEMISTRY",
	BC_IDC = "BC_IDC",
	BC_MACNEIL = "BC_MACNEIL",
	BC_PARTS = "BC_PARTS",
	BC_PDQ = "BC_PDQ",
	BC_PURCLEAN = "BC_PURCLEAN",
	BC_RYKO = "BC_RYKO",
	BC_SHADOW = "BC_SHADOW",
	BC_TSS = "BC_TSS",
	BC_VACUTECH = "BC_VACUTECH",
	CANCEL_ADDRESS = "CANCEL_ADDRESS",
	CARD = "CARD",
	CARD_PRODUCT_IMAGE = "CARD_PRODUCT_IMAGE",
	CARD_PRODUCT_NAME = "CARD_PRODUCT_NAME",
	CAROUSEL = "CAROUSEL",
	CAROUSEL_CHEMS = "CAROUSEL_CHEMS",
	CAROUSEL_CLEARANCE = "CAROUSEL_CLEARANCE",
	CAROUSEL_VISUAL_SEARCH = "CAROUSEL_VISUAL_SEARCH",
	CART_ICON_GO_TO_CART = "CART_ICON_GO_TO_CART",
	CART_VIEW = "CART_VIEW",
	CHAINS_N_ROLLERS = "CHAINS_N_ROLLERS",
	CHANGE_ADDRESS = "CHANGE_ADDRESS",
	CHARGE_TO_ACCOUNT = "CHARGE_TO_ACCOUNT",
	CHECKOUT_VIEW = "CHECKOUT_VIEW",
	CHEMISTRY_CATEGORY = "CHEMISTRY_CATEGORY",
	CLEAR_CART = "CLEAR_CART",
	CLEARANCE_NAV_BAR = "CLEARANCE_NAV_BAR",
	CONGRATS = "CONGRATS",
	CONNECTIVITY = "CONNECTIVITY",
	CONTACT_US = "CONTACT_US",
	CONTINUE_SHOPPING = "CONTINUE_SHOPPING",
	CREDIT_CARD = "CREDIT_CARD",
	EMPTY_CART = "EMPTY_CART",
	ENTER_CREDIT_CARD = "ENTER_CREDIT_CARD",
	FC_VIEW_CART = "FC_VIEW_CART",
	FILTERS = "FILTERS",
	FLOATING_CART = "FLOATING_CART",
	FREQUENTLY_BOUGHT_TOGETHER_ADD_TO_CART = "FREQUENTLY_BOUGHT_TOGETHER_ADD_TO_CART",
	FREQUENTLY_BOUGHT_TOGETHER_CLICKED_PRODUCT = "FREQUENTLY_BOUGHT_TOGETHER_CLICKED_PRODUCT",
	GO_TO_CART = "GO_TO_CART",
	GO_TO_PRODUCT = "GO_TO_PRODUCT",
	GROUND = "GROUND",
	HOME_VIEW = "HOME_VIEW",
	LOG_OUT = "LOG_OUT",
	LOGIN_TO_CHECKOUT = "LOGIN_TO_CHECKOUT",
	LOGIN_VIEW = "LOGIN_VIEW",
	MOTORS = "MOTORS",
	MY_ACCOUNT = "MY_ACCOUNT",
	MY_EQUIPMENT = "MY_EQUIPMENT",
	MY_SERVICE_REQUESTS = "MY_SERVICE_REQUESTS",
	OH_GO_TO_CART = "OH_GO_TO_CART",
	OVERNIGHT = "OVERNIGHT",
	PARTS_CATEGORY = "PARTS_CATEGORY",
	PDP_ADD_TO_CART = "PDP_ADD_TO_CART",
	PDP_GO_TO_CART = "PDP_GO_TO_CART",
	PDP_MORE_INFO = "PDP_MORE_INFO",
	PDP_VIEW = "PDP_VIEW",
	PLACE_ORDER = "PLACE_ORDER",
	PROCEED_TO_CHECKOUT = "PROCEED_TO_CHECKOUT",
	PROCEED_TO_LOGIN_CHECKOUT = "PROCEED_TO_LOGIN_CHECKOUT",
	PRODUCT_DETAILS_TAB = "PRODUCT_DETAILS_TAB",
	PUMPS = "PUMPS",
	PURCHASE_ORDER = "PURCHASE_ORDER",
	QO_GO_TO_CART = "QO_GO_TO_CART",
	QUESTION_MARK = "QUESTION_MARK",
	QUICK_ORDER = "QUICK_ORDER",
	QUICK_ORDER_SELECT_SITE = "QUICK_ORDER_SELECT_SITE",
	QUICK_ORDER_VIEW = "QUICK_ORDER_VIEW",
	REMOVE_ITEM = "REMOVE_ITEM",
	RP_ADD_TO_CART = "RP_ADD_TO_CART",
	RV_ADD_TO_CART = "RV_ADD_TO_CART",
	SEARCH = "SEARCH",
	SEARCH_CATALOG = "SEARCH_CATALOG",
	SEARCH_RESULTS_VIEW = "SEARCH_RESULTS_VIEW",
	SEARCH_VIEW = "SEARCH_VIEW",
	SHIP_HERE = "SHIP_HERE",
	SHIPMENT = "SHIPMENT",
	SIGNIN = "SIGNIN",
	SIGNIN_ATTEMP = "SIGNIN_ATTEMP",
	SIGNUP = "SIGNUP",
	SIGNUP_ATTEMP = "SIGNUP_ATTEMP",
	SIGNUP_VIEW = "SIGNUP_VIEW",
	SORT_BY_LIST = "SORT_BY_LIST",
	SORT_BY_OPTION = "SORT_BY_OPTION",
	SR_ADD_TO_CART = "SR_ADD_TO_CART",
	TRENDING = "TRENDING",
	USE_THIS_ADDRESS = "USE_THIS_ADDRESS",
	VERIFY_ADDRESS = "VERIFY_ADDRESS",
	VISUAL_SEARCH_BACK_TO_REQUEST_IMAGE = "VISUAL_SEARCH_BACK_TO_REQUEST_IMAGE",
	VISUAL_SEARCH_BAR = "VISUAL_SEARCH_BAR",
	VISUAL_SEARCH_CHANGE_LANGUAGE = "VISUAL_SEARCH_CHANGE_LANGUAGE",
	VISUAL_SEARCH_CLOSE = "VISUAL_SEARCH_CLOSE",
	VISUAL_SEARCH_ICON = "VISUAL_SEARCH_ICON",
	VISUAL_SEARCH_NEW_SEARCH = "VISUAL_SEARCH_NEW_SEARCH",
	VISUAL_SEARCH_REFINE = "VISUAL_SEARCH_REFINE",
	VISUAL_SEARCH_REFINE_SIMILAR_SEARCH = "VISUAL_SEARCH_REFINE_SIMILAR_SEARCH",
	VISUAL_SEARCH_REMOVE = "VISUAL_SEARCH_REMOVE",
	VISUAL_SEARCH_SHOW_LANGUAGES = "VISUAL_SEARCH_SHOW_LANGUAGES",
	VISUAL_SEARCH_UPLOAD = "VISUAL_SEARCH_UPLOAD",
	VISUAL_SEARCH_VIEW_MORE = "VISUAL_SEARCH_VIEW_MORE",
	WEIGHT_DIMS_TAB = "WEIGHT_DIMS_TAB",
	WELCOME_VIEW = "WELCOME_VIEW",
	EXIT_MODAL_VIEWED = "EXIT_MODAL_VIEWED",
	EXIT_MODAL_CHECKOUT_CLICKED = "EXIT_MODAL_CHECKOUT_CLICKED",
	EXIT_MODAL_DISMISSED = "EXIT_MODAL_DISMISSED",
}

export const EVENTS_BY_ID: Record<string, TrackingEvent> = {
	"tabs-Weight & Dimension": TrackingEvent.WEIGHT_DIMS_TAB,
	"tabs-Product Details": TrackingEvent.PRODUCT_DETAILS_TAB,
}

export const EVENTS_BY_CSS_CLASS_NAME: Record<string, TrackingEvent> = {
	"nyris__product-cta": TrackingEvent.VISUAL_SEARCH_VIEW_MORE,
	"nyris__hello-drop-zone": TrackingEvent.VISUAL_SEARCH_UPLOAD,
	"nyris__success-multiple-preview-collapse": TrackingEvent.VISUAL_SEARCH_REFINE,
	"nyris__success-multiple-preview-expand": TrackingEvent.VISUAL_SEARCH_REFINE,
	"nyris__success-multiple-preview-delete-collapse": TrackingEvent.VISUAL_SEARCH_REMOVE,
	"nyris__header-language-list-item": TrackingEvent.VISUAL_SEARCH_CHANGE_LANGUAGE,
	"nyris__header-language-label": TrackingEvent.VISUAL_SEARCH_SHOW_LANGUAGES,
	"nyris__product-similar-search": TrackingEvent.VISUAL_SEARCH_REFINE_SIMILAR_SEARCH,
	"nyris__action-wrapper-button": TrackingEvent.VISUAL_SEARCH_NEW_SEARCH,
	"go-back-button": TrackingEvent.VISUAL_SEARCH_BACK_TO_REQUEST_IMAGE,
}

export const EVENTS_BY_PATH: Record<string, TrackingEvent> = {
	"/auth/login": TrackingEvent.LOGIN_VIEW,
	"/shop/checkout": TrackingEvent.CHECKOUT_VIEW,
	"/shop/parts": TrackingEvent.PDP_VIEW,
	"/shop/search": TrackingEvent.SEARCH_VIEW,
	"/shop/cart-summary": TrackingEvent.CART_VIEW,
	"/shop/quick-order": TrackingEvent.QUICK_ORDER_VIEW,
	"/shop": TrackingEvent.HOME_VIEW,
}

export const integrateAnalyticsPlatforms = () => {
	try {
		const context = getContext()
		integrateGA()

		context.trackEvent = trackEvent
	} catch (e) {
		console.error("Error integratig analytics platforms: ", e)
	}
}

export const integrateGA = () => {
	const context = getContext()
	context.dataLayer = context.dataLayer || []
	context.gtag = function (...args: any[]) {
		context.dataLayer.push(args)
	}

	const GAKey = import.meta.env.VITE_GA_KEY
	if (!GAKey) {
		console.error(
			"Error: VITE_GA_KEY is not defined. Please check your environment variables."
		)
		return
	}

	addAnalyticsScript(`https://www.googletagmanager.com/gtag/js?id=${GAKey}`, () => {
		context.dataLayer = context.dataLayer || []
		context.gtag("js", new Date())
		context.gtag("config", GAKey)
	})
}

let lastPath = ""
export const trackCustomerPortalNavigation = (location: string) => {
	if (!location) return
	const normalizedLocation = location.toLowerCase()
	const path = Object.keys(EVENTS_BY_PATH).find((p) => normalizedLocation.includes(p))
	if (path && path != lastPath) {
		lastPath = path
		trackEvent(EVENTS_BY_PATH[path])
		setTimeout(() => (lastPath = ""), 1000)
	}
}

export const trackEvent = (event: string, details: any = {}, timeout = 0) => {
	setTimeout(() => {
		const context = getContext()
		context?.gtag("event", event, details)
	}, timeout)
}

const addAnalyticsScript = (src: string, callback: any) => {
	const script = document.createElement("script")
	script.src = src
	script.async = true
	if (callback) script.onload = callback
	script.onerror = (e) => {
		console.error(`Error loading script: ${src}`, e)
	}
	document.head.appendChild(script)
}

const getContext: any = () => window
